import { SubscriptionStatus as SubscriptionStatusApi } from '@vendasta/billing';

export enum SubscriptionStatus {
  Unset = 'Unset',
  Active = 'Active',
  Inactive = 'Inactive',
}

export function subscriptionStatusFromApi(sApi: SubscriptionStatusApi | undefined): SubscriptionStatus {
  switch (sApi) {
    case SubscriptionStatusApi.SUBSCRIPTION_STATUS_ACTIVE:
      return SubscriptionStatus.Active;
    case SubscriptionStatusApi.SUBSCRIPTION_STATUS_EXPIRED:
      return SubscriptionStatus.Inactive;
    default:
      return SubscriptionStatus.Unset;
  }
}

export function subscriptionStatusToApi(subscriptionStatus: SubscriptionStatus): SubscriptionStatusApi {
  switch (subscriptionStatus) {
    case SubscriptionStatus.Active:
      return SubscriptionStatusApi.SUBSCRIPTION_STATUS_ACTIVE;
    case SubscriptionStatus.Inactive:
      return SubscriptionStatusApi.SUBSCRIPTION_STATUS_EXPIRED;
    default:
      return SubscriptionStatusApi.SUBSCRIPTION_STATUS_UNSET;
  }
}

export function isSubscriptionStatus(str: string): str is SubscriptionStatus {
  return Object.values(SubscriptionStatus).includes(str as SubscriptionStatus);
}
